import {createRouter, createWebHistory} from 'vue-router'

const TranslationType = () => import('@/views/TranslationType.vue')
const Step1 = () => import('@/views/CheckoutStep1.vue')
const Step2 = () => import('@/views/CheckoutStep2.vue')
const Step3 = () => import('@/views/CheckoutStep3.vue')
const Step4 = () => import('@/views/CheckoutStep4.vue')
const Step5 = () => import('@/views/CheckoutStep5.vue')

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/:lang?/checkout',
            component: TranslationType,
            name: 'Translation Type',
        },
        {
            path: '/:lang?/checkout/:id',
            component: TranslationType,
            name: 'Translation Type Id',
        },
        {
            path: '/:lang?/checkout/step1',
            component: Step1,
            name: 'Step 1',
        },
        {
            path: '/:lang?/checkout/step2',
            component: Step2,
            name: 'Step 2',
        },
        {
            path: '/:lang?/checkout/step3',
            component: Step3,
            name: 'Step 3',
        },
        {
            path: '/:lang?/checkout/step4',
            component: Step4,
            name: 'Step 4',
        },
        {
            path: '/:lang?/checkout/step5',
            component: Step5,
            name: 'Step 5',
        },
    ]
})

export default router